import { Div, DestroyingContentSwitcher, Ref } from "@tblabs/truffle";
import { appendable } from "@tblabs/truffle/Core/appendable";
import { TabsSwitcher } from "./TabsSwitcher";


export class Tabs extends Div
{
    protected readonly switches: TabsSwitcher;
    protected readonly content: DestroyingContentSwitcher;

    constructor(private ref = new Ref<string>(""))
    {
        super();

        this.switches = new TabsSwitcher(this.ref);
        this.content = new DestroyingContentSwitcher(this.ref);

        this.Append(
            this.switches,
            this.content);
    }

    public Add(label: string, content: () => appendable | appendable[]): this
    {
        this.switches.Add(label);
        this.content.AddContent(label, content);

        return this;
    }
}
